import { setAlert } from "../alert";
import api from "../../../utils/api";
import { BULK_ACTION_TIMESHEET, BULK_ACTION_TIMESHEET_ERROR, DELETE_TIMESHEET_HOURS, DELETE_TIMESHEET_HOURS_ERROR, GENERATE_TIMESHEET_HOURS, GENERATE_TIMESHEET_HOURS_ERROR, GET_TIMESHEET_BULK_LIST, GET_TIMESHEET_BULK_LIST_ERROR, GET_TIMESHEET_HOURS, GET_TIMESHEET_HOURS_ERROR, GET_TIMESHEET_ID, GET_TIMESHEET_ID_ERROR, GET_TIMESHEET_LIST, GET_TIMESHEET_LIST_ERROR, GET_TIMESHEET_STATUS_LIST, GET_TIMESHEET_STATUS_LIST_ERROR, GET_TIMESHEET_WORKER_RATES, GET_TIMESHEET_WORKER_RATES_ERROR, RESET_TIMESHEET_DETAILS, RESET_TIMESHEET_HOUR_DETAILS, RESET_TIMESHEET_STATUS, SAVE_TIMESHEET, SAVE_TIMESHEET_ERROR, SAVE_TIMESHEET_HOURS, SAVE_TIMESHEET_HOURS_ERROR } from "../types";
import { download_file } from "../../../utils/general";
import { handleError } from "../errors";

export const get_timesheet_status_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/get-timesheet-status-list`);
        dispatch({
            type: GET_TIMESHEET_STATUS_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_TIMESHEET_STATUS_LIST_ERROR,
        });
    }
};

export const get_timesheet_list = (refNum, client, worker, status, startDate, endDate, projectName) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/get-timesheet-list`,
            {
                params: {
                    refNum: refNum,
                    clientName: client,
                    workerName: worker,
                    status: status,
                    fromDate: startDate,
                    toDate: endDate,
                    projectName: projectName,
                }
            }
        );
        dispatch({
            type: GET_TIMESHEET_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_TIMESHEET_LIST_ERROR,
        });
    }
};

export const get_bulk_action_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/get-bulk-action-list`);
        dispatch({
            type: GET_TIMESHEET_BULK_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_TIMESHEET_BULK_LIST_ERROR,
        });
    }
};

export const bulk_action_timesheet = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/sub-timesheet/bulk-update-timesheet-status`, bulkData)
        dispatch({
            type: BULK_ACTION_TIMESHEET,
            payload: true
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: BULK_ACTION_TIMESHEET_ERROR
        })
        return false;
    }
}

export const bulk_action_timesheet_download = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/sub-timesheet/bulk-action-timesheet-invoice`, bulkData)
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        return false;
    }
}

export const delete_bulk_timesheet = (refNumList) => async (dispatch) => {
    try {
        const res = await api.post(`api/sub-timesheet/bulk-delete-timesheet`, refNumList);
        dispatch(setAlert(res.data.message, "success"))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        return false;
    }
}

export const reset_timesheet_list = () => (dispatch) => dispatch({ type : RESET_TIMESHEET_STATUS });

export const reset_timesheet_details = () => (dispatch) => dispatch({ type : RESET_TIMESHEET_DETAILS });

export const reset_timesheet_hour_details = () => (dispatch) => dispatch({ type : RESET_TIMESHEET_HOUR_DETAILS });

export const save_subscriber_timesheet = (timesheet) => async (dispatch) => {
    try {
        const res = await api.post('api/sub-timesheet/save-timesheet', timesheet);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_TIMESHEET,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_TIMESHEET_ERROR })
        return false;
    }
}
export const get_timesheet_by_refnum = (timesheetRefNum) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/get-timesheet?refNum=${timesheetRefNum}`);
        dispatch({
            type: GET_TIMESHEET_ID,
            payload: res.data
        })
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_TIMESHEET_ID_ERROR,
        });
    }
}
export const delete_timesheet_hours = ( timesheeteRef , refNum ) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/delete-timesheet-hours?timeSheetRefNum=${timesheeteRef}&refNum=${refNum}`);
        dispatch({
            type: DELETE_TIMESHEET_HOURS,
            payload: res.data,
        });
        dispatch(setAlert(res.data.message, "success"));
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: DELETE_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};
export const generate_timesheet_schedule = ( client, worker, endDate ) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/generate-timesheet-schedule`, {
            params: {
                clientId: client,
                workerId: worker,
                payPeriodEndDate: endDate,
            }
        });
        dispatch({
            type: GENERATE_TIMESHEET_HOURS,
            payload: res.data,
        });
        //dispatch(setAlert(res.data.message, "success"));
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GENERATE_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};
export const get_timesheet_worker_rates = ( id ) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/get-timesheet-rates?workerId=${id}`);
        dispatch({
            type: GET_TIMESHEET_WORKER_RATES,
            payload: res.data,
        });
        //dispatch(setAlert(res.data.message, "success"));
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_TIMESHEET_WORKER_RATES_ERROR,
        });
        return false;
    }
};
export const get_timesheet_hours = ( timesheeteRef , refNum ) => async (dispatch) => {
    try {
        const res = await api.get(`api/sub-timesheet/get-timesheet-hours?timeSheetRefNum=${timesheeteRef}&refNum=${refNum}`);
        dispatch({
            type: GET_TIMESHEET_HOURS,
            payload: res.data,
        });
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};

export const save_subscriber_timesheet_hours = (timesheetHours) => async (dispatch) => {
    try {
        const res = await api.post('api/sub-timesheet/save-timesheet-hours', timesheetHours);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_TIMESHEET_HOURS,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_TIMESHEET_HOURS_ERROR })

        return false;
    }
}
//